import React from "react";
import { NavLink } from "react-router-dom";

export class CasinoMaratonSignIn extends React.Component {
    constructor(props) {
        super(props);
    }
    scrollToGames() {
        document.querySelector('#tabs').scrollIntoView({
            behavior: 'smooth'
        });
    }

    render() {
        return (
            <div className="casino-maraton-section">
                <h2>Moji podaci</h2>
                <div className="my-data sign-in">
                    <span className="place inactive">
                        <span className="image">
                            <span className="red-line"></span>
                            <span className="gray-line"></span>
                        </span>
                    </span>
                    <span className="points inactive">
                        <span className="image">
                            <span className="red-line"></span>
                            <span className="gray-line"></span>
                        </span>
                    </span>
                    <span className="points-total inactive">
                        <span className="image">
                            <span className="red-line"></span>
                            <span className="gray-line"></span>
                        </span>
                    </span>
                    <span className="joker inactive">
                        <span className="image">
                            <span className="red-line"></span>
                            <span className="gray-line"></span>
                        </span>
                    </span>
                    {!this.props.igracJeLogiran && this.props.resultsLoaded &&
                        <span className="log-in">
                            <div className="text">Prijavi se i iskušaj u Casino Maratonu!</div>
                            <div className="actions">
                                {!casino.config.fromNativeApp && <NavLink to="/login" className="login-btn">Prijavi se i zaigraj</NavLink>}
                                {casino.config.fromNativeApp && <button className="login-btn" onClick={() => location.href = 'https://m.supersport.hr/registracija'}>Prijavi se i zaigraj</button>}
                                <button className="registration-btn" onClick={() => location.href = 'https://m.supersport.hr/registracija'}>Registriraj se</button>
                            </div>
                        </span>}

                    {this.props.igracJeLogiran && this.props.resultsLoaded && this.props.isIntroPeriod &&
                        <span className="log-in">
                            <div className="text small">
                                <span className="icon yellow"></span>
                                Trebaš odigrati da bi sudjelovao! Kreni sada!
                            </div>
                            <div className="actions">
                                <button className="play-now-btn" onClick={() => this.scrollToGames()}>Zaigraj</button>
                            </div>
                        </span>}

                    {this.props.igracJeLogiran && this.props.resultsLoaded && !this.props.isIntroPeriod && !this.props.isFinished &&
                        <span className="log-in">
                            <div className="text small">
                                <span className="icon red"></span>
                                Nažalost, ispao si iz maratona! Treniraj naše <span style={{ color: '#aa0d19' }}> Casino utrke</span>!
                            </div>
                        </span>}
                    {this.props.igracJeLogiran && this.props.resultsLoaded && !this.props.isIntroPeriod && this.props.isFinished &&
                        <span className="log-in">
                            <div className="text">
                                <span className="icon yellow"></span>
                                <span style={{ color: '#aa0d19' }}> Casino maraton</span> je završen!
                            </div>
                        </span>}
                </div>
                <div className="divider"></div>
            </div>
        );
    }
}